/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useEffect, useState } from "react"
import { Link, useHistory } from "react-router-dom"
import { useRecoilValue } from "recoil"
import { getAccountInfo } from "../../api"
import { FLOW } from "../../config"
import { useAccount } from "../../hooks"
import { accountDataState } from "../../recoil/account"
import { flowDataState } from "../../recoil/flow"
import { Toast } from "../../service/alert"

interface IProps {
    title: string
    subTitle?: string
    backTo?: string | 'goback'
    disableBackTo?: boolean
    showSideBar?: boolean
}

const Header = React.memo((props: IProps) => {
    const { title, subTitle, backTo = 'goback', disableBackTo, showSideBar = false } = props
    const history = useHistory()

    const account = useRecoilValue(accountDataState)
    const flowData = useRecoilValue(flowDataState)
    const { logout } = useAccount()

    const [state, setState] = useState({
        visible: false
    })

    useEffect(() => {
        if (flowData.flow === FLOW.PHARMACIST_FAST_UPDATE_INVENTORY) {
            const mainElm = document.getElementById('main')
            if (!mainElm) return

            mainElm.style.marginTop = '0px'
        }
    }, [flowData.flow])

    return <header className={`${flowData.flow === FLOW.PHARMACIST_FAST_UPDATE_INVENTORY && 'd-none'}`}>
        <nav className="navbar navbar-expand-xl">
            {
                showSideBar && account.loginSession.userLocalType === "ADMIN" &&
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarPrescription" aria-controls="navbarPrescription" aria-expanded="false" aria-label="Toggle navigation" onClick={() => setState(prev => ({ ...prev, visible: true }))}>
                    <span className="navbar-toggler-icon"></span>
                </button>
            }
            <span className={`navbar-brand page-title ${!showSideBar && disableBackTo && 'w-100'}`} onClick={()=>{
                const account = getAccountInfo()
                if(account?.loginSession?.userLocalType == "PHARMACIST"){
                    navigator.clipboard.writeText(`https://phar-inv.medigoapp.com/pharmacy-login/${account?.loginSession?.mToken}`).then(res => {
                        Toast.fire({
                            icon: 'success',
                            title: 'Đã lưu đường dẫn vào bộ nhớ tạm',
                        })
                    })
                }
            }}>
                {title}<br />
                <small>{subTitle}</small>
            </span>
            <Link
                className={`btn-back ${disableBackTo && 'd-none'}`}
                to={backTo}
                onClick={() => {
                    if (backTo === 'goback') {
                        history.goBack()
                    }
                }}
            >
                <img src="./images/back.svg" width="{9}" alt="back" />
            </Link>
        </nav>

        <div className={`collapse navbar-collapse ${state.visible && 'show'}`} id="navbarPrescription">
            <a onClick={() => setState(prev => ({ ...prev, visible: false }))} className="menu-overlay"></a>
            <div className="bg-blue">
                <div className="d-flex align-items-center">
                    <img src="./images/logo.png" title="Medigo" className="img-fluid" width={65} alt='logo' />
                    <span>{account.doctor.mDisplayName}</span>
                </div>
            </div>
            <ul className="navbar-nav ml-auto menu-style">
                <li className="nav-item med-text-center">
                    <a className="nav-link nav-logout" onClick={() => {
                        logout()
                        history.push('/login')
                    }}>Đăng xuất</a>
                </li>
            </ul>
        </div>

    </header>
})

export default Header